export function getView(is_first, link) {
  return is_first && !!link
}
